<template>
    <div class="file-handler col-12">
        <!-- Box of uploaded file -->
        <UploadedFile v-if="isSubmitted" :text="uploadedText" @edited-file="editFile()" @deleted-file="deleteFile()" />
        <!-- File uploader button -->
        <FileUploader v-show="empty(file)" :name="uploaderInputName" :store-namespace="uploaderNamespace"
            :text="uploadText" classes="form-group" />
        <!-- Cropper -->
        <Cropper v-if="!empty(file) && !isSubmitted" :store-namespace="cropperNamespace" :image-url="file"
            @save-modified="saveModified" />
        <!-- Field for invoking errors -->
        <div class="form-group" v-if="!isSubmitted">
            <Field v-if="!empty(file)" :name="`unsaved_${type}`" type="hidden" rules="required" />
            <Field v-else :name="`original_${type}`" type="hidden" rules="required" />
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { capitalize, empty } from "../../../../helpers";
import { Field } from "vee-validate";
import Cropper from "../../../packages/views/cropper/Cropper";
import FileUploader from "../../../packages/views/file-uploader/Button";
import UploadedFile from "./../../partials/image-handler/UploadedFile"
import useFileUploader from "../../../packages/views/file-uploader/useFileUploader";

export default {
    components: {
        UploadedFile,
        Cropper,
        FileUploader,
        Field,
    },
    props: {
        type: {
            type: String,
            default: () => 'file'
        },
        uploadedText: {
            type: String,
        },
        uploadText: {
            type: String,
        },
        uploaderNamespace: {
            type: String,
            default: () => 'fileUploader/'
        },
        cropperNamespace: {
            type: String,
            default: () => 'cropper/'
        },
    },
    computed: {
        ...mapGetters({
            product: 'product/getProduct',
            file: 'fileUploader/getFiles',
            cropper: 'cropper/getFile',
        }),
    },
    setup(props) {
        const fileName = `original${capitalize(props.type)}`
        const {
            uploaderNamespace,
            cropperNamespace,
            uploaderInputName,
            deleteFile,
            editFile,
            saveModified,
            file,
            cropper,
            isSubmitted,
        } = useFileUploader()
        // for deleteFile
        uploaderNamespace.value = props.uploaderNamespace
        cropperNamespace.value = props.cropperNamespace
        uploaderInputName.value = fileName

        return {
            uploaderInputName,
            deleteFile,
            editFile,
            saveModified,
            empty,
            file,
            cropper,
            isSubmitted,
        }
    }
}
</script>
